import React from "react";
import { Row, Col } from "react-bootstrap";
import { useMasterContext } from "provider/MasterProvider";
import { useParksContext } from "provider/ParksProvider";
import { useMetaContext } from "provider/MetaProvider";

const ParkSelectedFilters = () => {
  const { filters, parksDispatch } = useParksContext();
  const { animals, locations, vehicles, bonusExperience } = useMasterContext();
  const { accommodation } = useMetaContext();

  // Map filter keys to corresponding master list
  const filterToMasterMap = {
    master_animal_id: animals,
    master_vehicle_id: vehicles,
    bonus_experience_id: bonusExperience,
    master_location_id: locations,
    accomodation_id: accommodation,
  };

  const getTitleFromMaster = (list, id) =>
    list?.find((item) => Number(item.value) === Number(id))?.label || null;

  const removeArrayItem = (key, itemToRemove) => {
    const newArray = filters[key].filter((item) => item !== itemToRemove);
    parksDispatch({
      type: "UPDATE_PARKS_FILTER",
      payload: { [key]: newArray.length > 0 ? newArray : 0 },
    });
  };

  const onRemove = (key) => {
    parksDispatch({
      type: "UPDATE_PARKS_FILTER",
      payload: { [key]: 0 },
    });
  };

  return (
    <Row className="mb-3">
      <Col>
        <div className="d-flex flex-wrap align-items-center gap-2">
          {Object.entries(filters)
            .filter(([_, value]) => value !== 0 && value !== "" && value !== null)
            .flatMap(([key, value]) => {
              const list = filterToMasterMap[key];

              // If no master list, skip rendering
              if (!list) return [];

              if (Array.isArray(value)) {
                return value
                  .filter((id) => id !== 0)
                  .map((id) => {
                    const label = getTitleFromMaster(list, id);
                    if (!label) return null;
                    return (
                      <span
                        key={`${key}-${id}`}
                        className="filter-sort px-4 py-2 d-flex align-items-center"
                        style={{ fontSize: "14px", cursor: "pointer" }}
                        onClick={() => removeArrayItem(key, id)}
                      >
                        {label}
                        <span className="ms-2">
                          <i className="fa-solid fa-x"></i>
                        </span>
                      </span>
                    );
                  });
              } else {
                const label = getTitleFromMaster(list, value);
                if (!label) return null;
                return (
                  <span
                    key={key}
                    className="filter-sort px-4 py-2 d-flex align-items-center"
                    style={{ fontSize: "14px", cursor: "pointer" }}
                    onClick={() => onRemove(key)}
                  >
                    {label}
                    <span className="ms-2">
                      <i className="fa-solid fa-x"></i>
                    </span>
                  </span>
                );
              }
            })}
        </div>
      </Col>
    </Row>
  );
};

export default ParkSelectedFilters;
